module.exports = __webpack_public_path__ + "img/slide-down.1b0b87dd.svg";